export function loadWalkMeScript({ walkMeSrc }) {
  if (document.getElementById('walkmescript')) return;
  const script = document.createElement('script');
  script.id = 'walkmescript';
  script.type = 'text/javascript';
  script.async = true;
  script.src = walkMeSrc;
  window._walkmeConfig = {
    smartLoad: true,
    isContainedInIframe: true
  };
  document.head.appendChild(script);
  const referenceScript = document.getElementsByTagName('script')[0];
  referenceScript.parentNode.insertBefore(script, referenceScript);
}

export function updateFortellisWalkMeData({ data = {} }) {
  window.Fortellis_WM_Variable = {
    orgId: data.orgId || '',
    userEmail: data.email || '',
    userName: data.userName || '',
    orgName: data.orgName || '',
    fortellisOrgType: data.fortellisDefinedType || '',
  };
}
